'use client';

import { motion } from 'motion/react';

import { ImageMedia } from '@/components/ImageMedia';
import type { Employee, Media } from '@/payload-types';
import { cn } from '@/utils/cn';
import { pushGTMEvent } from '@/utils/pushGTMEvent';

import styles from './EmployeeCard.module.scss';

type EmployeeCardProps = Employee & {
  index: number;
  className?: string;
};

export const EmployeeCard: React.FC<EmployeeCardProps> = (props) => {
  const { className, email, image, name, phone, role } = props;

  const handleClick =
    (meta: { contact_form: string; contact_name?: string }) => () => {
      pushGTMEvent({
        event: 'contact_click',
        ...meta,
      });
    };

  return (
    <motion.div className={cn(styles.card, className)}>
      {image && (
        <ImageMedia
          aspectRatio='portrait'
          image={(image as Media) || undefined}
          className={styles.media}
          responsiveWidths={{
            mobile: 343,
            desktop: 512,
            largeDesktop: 800,
          }}
        />
      )}
      <div className={styles.content}>
        {role && <span className={styles.role}>{role}</span>}
        {name && <span className={styles.name}>{name}</span>}
        {phone && (
          <a
            onClick={handleClick({
              contact_form: 'phone',
              contact_name: name,
            })}
            href={`tel:${phone}`}
            className={styles.phone}
          >
            {phone}
          </a>
        )}
        {email && (
          <a
            onClick={handleClick({
              contact_form: 'email',
              contact_name: name,
            })}
            href={`mailto:${email}`}
            className={styles.email}
          >
            {email}
          </a>
        )}
      </div>
    </motion.div>
  );
};
